<template>
  <div>
  </div>
</template>

<script>
export default {
  name: 'children-test-view',
  data: function () {
    return {}
  }
}
</script>

<style scoped>

</style>
